import { render } from "./ComponenteBackup.vue?vue&type=template&id=63a79ca6&scoped=true"
import script from "./ComponenteBackup.vue?vue&type=script&lang=js"
export * from "./ComponenteBackup.vue?vue&type=script&lang=js"

import "./ComponenteBackup.vue?vue&type=style&index=0&id=63a79ca6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a79ca6"]])

export default __exports__